export default __webpack_public_path__ + "static/media/151-security-system-1.e68e7192.png";